import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import { MouseEvent } from 'react';
import { alpha } from '@mui/material';

type Props = {
  onClick: (event: MouseEvent) => void;
  className?: string;
};

export const RemoveElementBtn = ({ onClick, className }: Props) => {
  return (
    <IconButton
      onClick={onClick}
      className={`w-6 h-6 rounded-full ${className ?? ''}`}
      aria-label="remove element"
      sx={(theme) => ({
        color: theme.palette.text.secondary,
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${alpha(theme.palette.text.secondary, 0.45)}`,
        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.45)',
        transition: theme.transitions.create(['background-color', 'border-color', 'color', 'box-shadow']),
        '&:hover': {
          color: theme.palette.text.primary,
          borderColor: theme.palette.primary.main,
          backgroundColor: theme.palette.background.paper,
          boxShadow: `0 0 12px ${alpha(theme.palette.primary.main, 0.5)}`,
        },
      })}
    >
      <ClearIcon fontSize="small" className="size-4" />
    </IconButton>
  );
};
